import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CoinflipWinNotificationService } from '../../services/coinflip-win-notification.service';
import { CoinflipWinNotificationComponent } from '../coinflip-win-notification/coinflip-win-notification.component';
import { CoinflipDeprecatedService } from '@old-app/coinflip/coinflip.service';

@Component({
  selector: 'app-coinflip-win-notification-container',
  standalone: true,
  imports: [CoinflipWinNotificationComponent],
  templateUrl: './coinflip-win-notification-container.component.html',
  styleUrl: './coinflip-win-notification-container.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoinflipWinNotificationContainerComponent {
  protected readonly notificationService = inject(CoinflipWinNotificationService);
  private readonly coinflipService = inject(CoinflipDeprecatedService);

  onClose(): void {
    this.notificationService.dismiss();
  }

  async onAcceptWinnings(): Promise<void> {
    const gameId = this.notificationService.getGameIdAndDismiss();
    if (gameId !== null) {
      await this.coinflipService.claimWinnings(gameId);
    }
  }
}
